
import httpService from "@src/utility/httpService";
import { config } from '@uhg-abyss/web/tools/config';
import { affordabilityEndPoints } from "@src/apps/constants/ApiMappingConstants/affordabilityEndPoints";
const _httpService = new httpService();

const apiDomainInternal = config('API_DOMAIN_INTERNAL');

_httpService.setBaseURL(apiDomainInternal);
export const getRadiologyTableData = async (payload: any) => {
    const response:any = await _httpService.push(
        affordabilityEndPoints.radiologyMPINTable,
        payload
      );
    return response;
};